import React from 'react';
import PageNotFound from '@/Framework/UI/Pages/PageNotFound';
import { getPageTitle } from '@/finsight/ui/common/helpers';

const PageNotFoundWrp = () => (
  <PageNotFound title={ getPageTitle('Page not found') } />
);

export default PageNotFoundWrp;
